import { BLUE_PR4, ORANGE_PR_2, RED_PR_1, YELLOW_PR3, GREEN_PR5, DEFAULT_COLOR_PR } from "../assets/Styles";

const capitalize = (word: string) => {
    return word.charAt(0).toUpperCase() + word.slice(1)
}

const PRIORITY_COLORS: Record<string, string> = {
    'PR1': RED_PR_1,
    'PR2': ORANGE_PR_2,
    'PR3': YELLOW_PR3,
    'PR4': BLUE_PR4,
    'PR5': GREEN_PR5,
}

const getPriorityColor = (priorityName: string): string => {
    return PRIORITY_COLORS[priorityName] ?? DEFAULT_COLOR_PR
}

export { capitalize, getPriorityColor }
